export default "__VITE_ASSET__DlZI$wPI__"